// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".complete-your-report-teaser[data-v-996bc018]{margin-bottom:25px}@media only screen and (min-width:600px){.complete-your-report-teaser[data-v-996bc018]{margin-bottom:30px}}.complete-your-report-teaser__button-label[data-v-996bc018]{margin:0 5px 14px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
